import "core-js/modules/web.dom.iterable";
//
//
//
//
import * as echarts from 'echarts';
import { getAction } from '@/api/manage';
export default {
  data: function data() {
    return {
      analysisType: 11,
      yAxisr: []
    };
  },
  mounted: function mounted() {
    this.getPressureData();
  },
  methods: {
    //气压差数据
    getPressureData: function getPressureData() {
      var _this = this;

      // 请求数据
      var params = {
        stime: '2022-10-01',
        etime: '2022-10-01',
        scopeId: 259,
        column: 'data_time',
        order: 'asc',
        dataType: this.analysisType,
        type: 1
      }; //气压差数据

      getAction('/online/st54/chart', params).then(function (res) {
        if (res.success) {
          var pressure = res.result.query.factors[0];
          console.log('pressure', pressure);
          var dataTime = [];
          res.result.records.forEach(function (element) {
            dataTime.push(element.dataTime);
            console.log('element', element);

            if (element[pressure.code]) {
              _this.yAxisr.push(element.records[pressure.code].value);

              console.log('this.yAxisr', _this.yAxisr);
            }
          }); // this.PinformationChart = temp
          // this.spanData = res.result
          // this.xAxisSpanData = []
          // res.result.forEach((item) => {
          //   this.xAxisSpanData.push(item.dateTime)
          // })

          _this.$nextTick(function () {// this.getPressureData()
          });

          var chartDom = document.getElementById('pressure');
          var myChart = echarts.init(chartDom);
          var option = {
            tooltip: {
              trigger: 'axis',
              axisPointer: {
                type: 'cross',
                label: {
                  backgroundColor: '#6a7985'
                }
              }
            },
            legend: {
              data: [pressure.title]
            },
            toolbox: {
              feature: {
                saveAsImage: {}
              }
            },
            grid: {
              left: '4%',
              right: '4%',
              bottom: '9%',
              containLabel: true
            },
            xAxis: [{
              type: 'category',
              boundaryGap: false,
              data: dataTime,
              axisLine: {
                lineStyle: {
                  color: '#fff'
                }
              }
            }],
            yAxis: [{
              type: 'value',
              axisLine: {
                lineStyle: {
                  color: '#fff'
                }
              }
            }],
            series: [{
              name: '排气压力',
              type: 'line',
              stack: 'Total',
              areaStyle: {},
              emphasis: {
                focus: 'series'
              },
              data: _this.yAxisr
            }]
          };
          myChart.setOption(option);
        }
      });
    }
  }
};